export const createHeadingLink = (
	getHeadingLinkPath: (() => string | null) | undefined,
	headingId: string,
): string | undefined => {
	const path = getHeadingLinkPath?.();

	if (!path) {
		return undefined;
	}

	// `window.location` is not available during SSR; heading links are only meaningful client-side.
	if (typeof window.location === 'undefined') {
		return undefined;
	}

	const url = new URL(window.location.origin + path);
	url.hash = encodeURIComponent(headingId);

	return url.toString();
};
